<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="currencyAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
<!--                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">-->
<!--                    <label for="adults_qnt" class="form-label">Adults qnt:</label>-->
<!--                    <input id="adults_qnt" class="form-control" name="adults_qnt" v-model="formData.adults_qnt" placeholder="adults qnt" :class="classes" type="number">-->
<!--                  </ValidationProvider>-->
<!--                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">-->
<!--                    <label for="children_qnt" class="form-label">Children qnt:</label>-->
<!--                    <input id="children_qnt" class="form-control" name="children_qnt" v-model="formData.children_qnt" placeholder="children qnt" :class="classes" type="number">-->
<!--                  </ValidationProvider>-->
<!--                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">-->
<!--                    <label for="price" class="form-label">Price:</label>-->
<!--                    <input id="price" class="form-control" name="price" v-model="formData.price" placeholder="price" :class="classes" type="text">-->
<!--                  </ValidationProvider>-->
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="continent_id" class="form-label">Room Base:</label>
                    <multiselect v-model="formData.roomBase" placeholder="Select Room Base" id="continent_id" :custom-label="customLabel" :class="classes"  :close-on-select="true" track-by="id" :options="regions">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const page = 'room'
export default {
  name: 'CityAdd',
  data () {
    return {
      page: page,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      regions: [],
      formData: {
        title_l: {}
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
      })
    }
    this.getCreateData().then((res) => {
      this.regions = res
    })
  },
  methods: {
    ...mapActions({
      create: page + '/create',
      update: page + '/update',
      getCreateData: page + '/getCreateData',
      getData: page + '/getData'
    }),
    checkValidation (data) {
      return data
    },
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          this.formData.room_base_id = this.formData.roomBase.id
          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + page)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + page)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
